import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { ArgumentsList, ShowDeprecatedArgumentsButton } from "./arguments-list.js";
import { Directive } from "./directive.js";
import { FieldCard } from "./field-card.js";
const FieldDocumentation = (t0) => {
  const $ = c(2);
  const {
    field
  } = t0;
  let t1;
  if ($[0] !== field) {
    t1 = /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(FieldCard, { field }),
      /* @__PURE__ */ jsx(Arguments, { field }),
      /* @__PURE__ */ jsx(Directives, { field })
    ] });
    $[0] = field;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const Arguments = (t0) => {
  const $ = c(11);
  const {
    field
  } = t0;
  const [showDeprecated, setShowDeprecated] = useState(false);
  if (!("args" in field)) {
    return null;
  }
  let args;
  let deprecatedArgs;
  let t1;
  if ($[0] !== field.args) {
    args = [];
    deprecatedArgs = [];
    for (const argument of field.args) {
      if (argument.deprecationReason) {
        deprecatedArgs.push(argument);
      } else {
        args.push(argument);
      }
    }
    t1 = /* @__PURE__ */ jsx(ArgumentsList, { title: "ARGUMENTS", args });
    $[0] = field.args;
    $[1] = args;
    $[2] = deprecatedArgs;
    $[3] = t1;
  } else {
    args = $[1];
    deprecatedArgs = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== args || $[5] !== deprecatedArgs || $[6] !== showDeprecated) {
    t2 = deprecatedArgs.length > 0 && (showDeprecated || args.length === 0 ? /* @__PURE__ */ jsx(ArgumentsList, { title: "DEPRECATED ARGUMENTS", args: deprecatedArgs }) : /* @__PURE__ */ jsx(ShowDeprecatedArgumentsButton, { onClick: () => setShowDeprecated(true) }));
    $[4] = args;
    $[5] = deprecatedArgs;
    $[6] = showDeprecated;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t1,
      t2
    ] });
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
const Directives = (t0) => {
  var _a;
  const $ = c(9);
  const {
    field
  } = t0;
  const directives = (_a = field.astNode) == null ? void 0 : _a.directives;
  if (!(directives == null ? void 0 : directives.length)) {
    return null;
  }
  let t1;
  if ($[0] !== directives.length) {
    t1 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-directives-list-header", children: [
      "DIRECTIVES",
      " ",
      /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-directives-list-count", children: [
        "· ",
        directives.length
      ] })
    ] });
    $[0] = directives.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== directives) {
    t2 = directives.map(_temp);
    $[2] = directives;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-directives-list-body", children: t2 });
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-directives-list", children: [
      t1,
      t3
    ] });
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(directive) {
  return /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-directive-row", children: /* @__PURE__ */ jsx(Directive, { directive }) }, directive.name.value);
}
export {
  FieldDocumentation
};
//# sourceMappingURL=field-documentation.js.map
